import { Modal, ConfigProvider } from 'antd'
import { createRoot } from 'react-dom/client'

const BetkoPopupModal = ({
  title,
  description,
  actionContent,
  visible,
  onClose,
  isContentCentered = true,
  hasBorder = false,
  isHelpMenu = false,
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            maskBg: 'rgba(0, 0, 0, 0.6)',
            borderRadius: 12,
            padding: 16,
            colorText: 'white',
            textAlign: isContentCentered ? 'center' : 'left',
            colorIcon: !isHelpMenu ? '#D6FF00' : 'white',
            colorIconHover: '#D6FF00',
          },
        },
      }}
    >
      <Modal
        open={visible}
        onCancel={onClose}
        footer={null}
        closable={true}
        maskClosable={true}
        centered
        width='auto'
        className={!title ? 'commentPopup' : isHelpMenu ? 'helpPopup' : ''}
        modalRender={(modalContent) => (
          <div
            style={{
              background: !hasBorder
                ? 'linear-gradient(135deg, #40445E, #111219)'
                : '#2b3240',
              borderRadius: '0.5rem',
              minWidth: '250px',
              maxWidth: '650px',
              border: hasBorder ? '2px solid #D6FF00' : '',
              color: 'white',
            }}
          >
            {modalContent}
          </div>
        )}
      >
        {title && (
          <span
            style={{
              color: !isHelpMenu ? '#D6FF00' : 'white',
              fontSize: '18px',
            }}
          >
            {title}
          </span>
        )}
        <div
          style={{
            borderTop: isHelpMenu
              ? '1px solid white'
              : title
              ? '1px solid #D6FF00'
              : 'none',
            paddingTop: title ? '16px' : '0px',
          }}
        >
          <div
            style={{ fontSize: '16px', marginBottom: title ? '16px' : '0px' }}
          >
            {description}
          </div>
          <div
            style={{
              display: 'flex',
              gap: '8px',
              justifyContent: isContentCentered ? 'center' : 'start',
            }}
          >
            {typeof actionContent === 'function'
              ? actionContent(() => onClose())
              : actionContent}
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  )
}

export const betkoPopupWithAction = (
  title,
  description,
  actionContent,
  { isContentCentered = true, hasBorder = false, isHelpMenu = false } = {}
) => {
  const container = document.createElement('div')
  document.body.appendChild(container)
  const root = createRoot(container)

  const closePopup = () => {
    root.unmount()
    document.body.removeChild(container)
  }

  root.render(
    <BetkoPopupModal
      title={title}
      description={description}
      actionContent={actionContent}
      visible={true}
      onClose={closePopup}
      isContentCentered={isContentCentered}
      hasBorder={hasBorder}
      isHelpMenu={isHelpMenu}
    />
  )
}
